import {
  Tabs as ChakraTabs,
  TabsProps as ChakraTabsProps,
} from "@chakra-ui/react";

export const Tabs = (props: ChakraTabsProps) => {
  return <ChakraTabs variant="subtle" {...props} />;
};
